import * as React from 'react';
import { SVGProps } from 'react';

const IconFractureFolderSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 1.7A.7.7 0 0 1 .7 1h5.886a1 1 0 0 1 .707.293l1.414 1.414A1 1 0 0 0 9.414 3H13a1 1 0 0 1 1 1v8.3a.7.7 0 0 1-.7.7H1a1 1 0 0 1-1-1V1.7Z"
      fill="var(--color-bg-caution)"
    />
    <path
      d="M0 3.7A.7.7 0 0 1 .7 3H13a1 1 0 0 1 1 1v8.3a.7.7 0 0 1-.7.7H1a1 1 0 0 1-1-1V3.7Z"
      fill="var(--color-bg-warning)"
    />
    <path
      d="M11.874 7.64a.497.497 0 0 0-.358-.62.53.53 0 0 0-.653.34l-1.842 6a.497.497 0 0 0 .358.62.531.531 0 0 0 .653-.34l.731-2.382c.295.01.572.03.827.056.46.047.853.114 1.169.18a8.273 8.273 0 0 1 .828.22l.041.014.01.003.001.001a.268.268 0 0 0 .342-.14.246.246 0 0 0-.146-.324l-.098.232.098-.232h-.003l-.004-.002-.013-.005a3.36 3.36 0 0 0-.237-.077 8.772 8.772 0 0 0-.705-.178 12.15 12.15 0 0 0-1.958-.243l.959-3.123Z"
      fill="var(--color-typo-normal)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.915 10.763a12.878 12.878 0 0 1 1.02.086c.354.045.664.1.926.154h.001l.008.002h.003a10.294 10.294 0 0 1 .69.174l.015.005c.072.021.13.04.171.054l.016.005.034.012h.002a.593.593 0 0 0 .009.004h.003l.002.002.014.005.003.001h.002a.282.282 0 0 1 .076.045.242.242 0 0 1 .067.29.268.268 0 0 1-.32.136h-.001l-.003-.001-.009-.003h-.002l-.003-.002h-.002l-.009-.004a2.326 2.326 0 0 0-.025-.009l-.016-.005a4.786 4.786 0 0 0-.168-.054 7.658 7.658 0 0 0-.65-.164l-.01-.002a11.155 11.155 0 0 0-1.667-.22 11.97 11.97 0 0 0-.329-.016l-.731 2.382a.53.53 0 0 1-.653.34.497.497 0 0 1-.358-.62l1.842-6a.53.53 0 0 1 .653-.34c.279.077.44.355.358.62l-.96 3.123Zm.572 1.546-.5 1.624c-.251.82-1.112 1.222-1.875 1.01-.78-.216-1.306-1.033-1.047-1.877l1.842-6c.252-.82 1.113-1.22 1.876-1.01.78.217 1.306 1.034 1.047 1.878l-.598 1.946c.318.044.602.096.848.147a9.827 9.827 0 0 1 1.008.27l.066.023.004.001.02.008.007.002.003.001h.001c.63.24 1.002.965.714 1.649a1.268 1.268 0 0 1-1.612.689l-.002-.001-.024-.009a7.238 7.238 0 0 0-.712-.188c-.284-.06-.642-.12-1.064-.163h-.002Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconFractureFolderSizeS;
